const items = {
	reportType: [
		{
			id: 0,
			name: "report.customer.reportType.all",
		},
		{
			id: 1,
			name: "report.customer.reportType.separateRegion",
		},
	],
	region: [
		{
			key: "north",
			name: "report.customer.region.north",
		},
		{
			key: "center",
			name: "report.customer.region.center",
		},
		{
			key: "south",
			name: "report.customer.region.south",
		},
	],
}

export default items;